// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: `具有该名称的布局已存在`,
    ACCEPT: `接受`,
    ACCEPT_ALL: `全部接受`,
    ACCEPT_REJECT_TRANSFER_PENDING: `批准待定`,
    ACCEPTED: `已接受`,
    ACCOUNT: `帐户`,
    ACCOUNT_ADDRESS: `帐户地址`,
    ACCOUNT_COUNTRY: `帐户所在国家`,
    ACCOUNT_END: `帐户结束`,
    ACCOUNT_NAME: `帐户名称`,
    ACCOUNT_NUMBER: `帐号`,
    ACCOUNT_NUMBER_REQUIRED: `须有帐号`,
    ACCOUNTS: `帐户`,
    ACCUMULATED_DAYS_ON_RENT: `累积出租的天数`,
    ACCUMULATED_DAYS_RENTED: `累积出租的天数`,
    ACTIONS: `操作`,
    ACTIVE_WARRANTY: `有效保修`,
    ACTIVE_WARRANTY_CLICK_FOR_DETAIL: `有效保修（单击了解详情）`,
    ACTIVE_WARRANTY_Y_N: `有效保修(Y/N)`,
    ACTUAL_AMOUNT_OF_USE: `实际使用量`,
    ACTUAL_AUDIT: `实际审计`,
    ACTUAL_AUDIT_DATE: `实际审计日期`,
    ACTUAL_COURIER_NAME: `实际承运商名称`,
    ACTUAL_H: `实际小时数`,
    ACTUAL_HOURS: `实际小时数`,
    ACTUAL_PC:`实际草捆`,
    ADD_CLAIM: `添加索赔`,
    ADD_CLAIMS: `添加索赔`,
    ADD_COMPONENT: `添加部件`,
    ADD_OPTION: `添加选项`,
    ADD_REP: `附加修理`,
    ADD_TO_AUDIT: `添加至审计`,
    ADDITIONAL: `其他`,
    ADDITIONAL_COMMENTS: `附加备注`,
    ADDITIONAL_REPAIR: `附加修理`,
    ADDITIVE: `补贴`,
    ADDRESS: `地址`,
    ADDRESS_LINE1: `地址行1`,
    ADDRESS_LINE1_REQUIRED: `需要地址行1`,
    ADDRESS_LINE2: `地址行2`,
    ADJ_CLM: `调整索赔`,
    ADJUST_CLAIM: `调整索赔`,
    ADJUSTED_HOURS: `调整后的小时数`,
    ADJUSTED_QUANTITY: `调整数量`,
    ADJUSTMENT_TYPE: `调整类型`,
    ADVANCED_CLAIM_SUMMARY: `高级摘要索赔`,
    AFTER_DELIVERY_INSPECTION: `交付后检查`,
    AGENCY_NAME: `派出所名称`,
    ALL: `全部`,
    ALL_ACCOUNTS: `所有帐户`,
    ALL_CLAIMS: `全部索赔`,
    ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: `所有索赔都要接受审查（详细信息，参见JD WAM 110.08）`,
    ALL_CLAIMS_TAB: `所有索赔 ({count, number})`,
    ALL_PART_REQUESTS: `所有零件请求`,
    ALL_PART_REQUESTS_WITH_COUNT: `所有零件请求 ({count})`,
    ALL_PARTS_RETURNED: `已返回所有零件`,
    AMOUNT: `金额`,
    AMOUNT_1: `金额 1`,
    AMOUNT_2: `金额 2`,
    AMOUNT_3: `金额 3`,
    AMOUNT_OF_USE: `使用量`,
    AMOUNT_OF_USE_ACCEPETD: `接受的使用量`,
    AMOUNT_OF_USE_CREATED_SUCCESSFULLY: `使用量创建成功`,
    AMOUNT_OF_USE_HISTORY_WITH_COUNT: `使用量历史记录 ({count})`,
    AMOUNT_OF_USE_IS_REQUIRED: `需要填写用量`,
    AMOUNT_OF_USE_REJECTED: `拒绝的使用量`,
    AMOUNT_OF_USE_REQUESTS_STATUS: `使用量请求状态`,
    AMOUNT_OF_USE_REQUESTS_WITH_COUNT: `使用请求数量({count})`,
    AMOUNT_OF_USE_REQUIRED: `使用量必填`,
    AMOUNT_OF_USE_UNITS_REQUIRED: `使用量单位必填`,
    AMOUNT_RECORDED: `记录的使用量`,
    AMOUNT_TO_BE_DEBITED: `要借记的金额`,
    APLYPIP: `申请 PIP`,
    APPLICATION: `用途`,
    APPLICATION_IS_REQUIRED: `需要填写用途`,
    APPLY: `应用`,
    APPLY_TRAVEL: `申请差旅`,
    APPROVAL_DEALER_COMMENTS: `批准经销商备注`,
    APPROVAL_DETAILS: `批准详情`,
    APPROVAL_LEVELS: `批准级别`,
    APPROVAL_REMARKS: `批准备注`,
    APPROVAL_STATUS: `审批状态`,
    APPROVE: `批准`,
    APPROVE_AMOUNT_OF_USE: `批准使用量`,
    APPROVE_LABOR_RATE: `批准人工费率`,
    APPROVE_MACHINE_STATUS_UPDATE: `批准机器状态更新`,
    APPROVE_PIP_CODE_REQUEST: `批准 PIP代 码请求`,
    APPROVE_SPECIAL_ALLOWANCE_CLAIM: `批准特殊索赔`,
    APPROVED: `批准`,
    APPROVED_CORE_VALUE: `批准的核心价值金额`,
    APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: `批准日期不可早于设置日期`,
    APPROVED_DIAGNOSTIC_AMOUNT: `批准的诊断金额`,
    APPROVED_DIAGNOSTIC_HOURS: `批准的诊断时间`,
    APPROVED_IS_REQUIRED: `需要填写批准日期`,
    APPROVED_LABOR_ADDITIVE: `批准的工时补贴`,
    APPROVED_LABOR_AMOUNT: `批准的工时费`,
    APPROVED_LABOR_HOURS: `批准的工时`,
    APPROVED_LABOR_TOTAL: `批准的人工总计`,
    APPROVED_ON_SHELF_COST: `批准的上架成本`,
    APPROVED_OTHER_CREDITS: `批准的其他赔付`,
    APPROVED_PARTS: `批准的零件`,
    APPROVED_PARTS_ADDITIVE: `批准的零件补贴`,
    APPROVED_PARTS_TOTAL: `批准的零件总计`,
    APPROVED_REJECTED: `批准/拒绝`,
    APPROVED_REPAIR_AMOUNT: `批准的修理金额`,
    APPROVED_REPAIR_HOURS: `批准的维修时间`,
    APPROVED_TAXES_TOTAL: `批准的税收总计`,
    APPROVED_TRAVEL_TOTAL: `批准的差旅金额`,
    APPROVER: `审批人`,
    ASCENDING: `升序`,
    ATTACHMENTS: `附件`,
    AUDIT_NUMBER: `审计编号`,
    AUDIT_PLANNED: `计划的审计`,
    AUDIT_REQUIREMENT: `审计要求`,
    AUDIT_RESULTS: `审计结果`,
    AUDIT_STATUS: `审计状态`,
    AUDIT_SUBMITTED_SUCCESSFULLY: `审计已成功提交`,
    AUDIT_SUMMARY: `审计汇总`,
    AUDIT_TYPE: `审计类型`,
    AUDITS: `审计`,
    AUDITS_DUE_WITH_COUNT: `{countToDisplay} 审计到期`,
    AUDITS_DUE_WITHIN_30_DAYS: `{countToDisplay} {count, plural, one {audit} other {audits}} 在 30 天内到期`,
    AUDITS_PAST_DUE_WITH_COUNT: `{countToDisplay} {count, plural, one {audit} other {audits}} 过期`,
    AUTHORIZATION_NUMBER: `授权号`,
    AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: `从经销商业务系统自动提交`,
    AVAILABLE: `可用`,
    AVAILABLE_COLUMNS: `可用的列`,
    AVERAGE_DIAGNOSTICS_HOURS: `平均诊断时数`,
    AVERAGE_LUG_HEIGHT: `平均 凸耳 高度`,
    AVERAGE_LUG_HEIGHT_IS_REQUIRED: `需要填写平均凸耳高度`,
    AVERAGE_REPAIR_HOURS: `平均修理时数`,
    AVERAGE_REPLACEMENT_HOURS: `平均更换时数`,
    AVERAGE_TECH_PAY_RATE: `技术人员平均报酬费率`,
    BACK: `返回`,
    BACK_TO_AUDIT: `返回审计`,
    BASE_MACHINE: `基本机器`,
    BASE_MACHINE_IMPLEMENTS: `基本机器农具`,
    BASE_MACHINE_PIN: `基本机器PIN`,
    BASIC_WARRANTY_ENDS: `基本保修结束`,
    BASIC_WARRANTY_ESTIMATOR: `预估基本保修期`,
    BASIC_WARRANTY_STARTS: `基本保修开始`,
    BASIS_FOR_SETTLEMENT: `结算基本情况`,
    BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: `结算基本情况 / 审计意见`,
    BASIS_FOR_SETTLEMENT_IS_REQUIRED: `需要填写结算基本情况`,
    BATTERY: `电池`,
    BEGIN_DATE: `开始日期`,
    BRANCH: `分支`,
    BUILT: `制造日期`,
    BUSINESS_END: `业务结束`,
    CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: `这台机器能否再次投入使用？`,
    CANCEL: `取消`,
    CERTIFIED_LETTER_SENT: `挂号信寄送日期`,
    CGST: `CGST`,
    CHANGE_RESPONSIBLE_DEALER: `更改负责经销商`,
    CHANGE_STATUS: `变更状态`,
    CHANGE_STATUS_FOR: `更改 {pin} 的状态`,
    CHANGED: `更改`,
    CHANGED_BY: `更改人`,
    CHANGED_ON: `更改日期`,
    CHINESE: `中文`,
    CITY: `城市`,
    CITY_REQUIRED: `所需城市`,
    CLAIM: `索赔`,
    CLAIM_COUNT_WITH_PARENTHESIS: `({countToDisplay} {count, plural, one {索赔} other {索赔}})`,
    CLAIM_DEBIT: `索赔扣款`,
    CLAIM_DETAILS: `索赔详情`,
    CLAIM_DRAFT: `草稿`,
    CLAIM_HISTORY: `24个月的索赔历史记录`,
    CLAIM_HISTORY_WITH_COUNT: `24个月的索赔历史记录 ({count})`,
    CLAIM_NUMBER: `索赔号`,
    CLAIM_RECOVER_PERCENTAGE: `({percentage}%)`,
    CLAIM_SEARCH: `索赔搜索`,
    CLAIM_STATUS: `索赔单状态`,
    CLAIM_TYPE: `索赔类型`,
    CLAIM_TYPES: `索赔类型`,
    CLAIM_UPDATED_SUCCESSFULLY: `索赔更新成功`,
    CLAIM_VALUE: `索赔值`,
    CLAIM_VALUE_DETAILS: `索赔额详细信息`,
    CLAIM_WITH_NUMBER: `索赔 {claimNumber}`,
    CLAIMS: `索赔`,
    CLAIMS_IN_PROGRESS: `索赔处理中`,
    CLAIMS_IN_PROGRESS_WITH_COUNT: `索赔处理中 ({count})`,
    CLAIMS_OVERVIEW: `索赔概述`,
    CLAIMS_OVERVIEW_TAB: `索赔概述 ({count})`,
    CLAIMS_WITH_COUNT: `{count} 索赔`,
    CLICK_FOR_DETAILS: `（单击查看详细信息）`,
    CLICK_TO_VIEW_ALL: `单击查看所有内容`,
    CLOSE: `关闭`,
    CLOSED_PART_REQUESTS: `封闭的部分请求`,
    CLOSING: `关闭`,
    CLOSING_ACCOUNT: `关闭帐户`,
    CLOSING_ACCOUNT_WITH_COUNT: `关闭帐户（{count}）`,
    CODE: `代码`,
    COLLAPSE_ALL: `全部折叠`,
    COMMENT: `备注`,
    COMMENTS: `备注`,
    COMMENTS_IS_REQUIRED: `需要填写备注`,
    COMMENTS_TO_DEALER: `写给经销商的备注`,
    COMMON_LABOR_TYPES_WARNING: `并非所有的人工类型都可用于所选帐户`,
    COMPANY: `迪尔公司`,
    COMPANY_CONTRIBUTION: `迪尔公司分摊金额`,
    COMPANY_CONTRIBUTION_IS_REQUIRED: `需要填写迪尔公司分摊金额`,
    COMPLAINT_CAUSE: `投诉的诊断是什么？`,
    COMPLAINT_CAUSE_IS_REQUIRED: `需要诊断投诉`,
    COMPLAINT_CORRECTION: `如何修复投诉？`,
    COMPLAINT_CORRECTION_IS_REQUIRED: `需要修复投诉`,
    COMPLETE: `完成`,
    COMPLETED: `完成日期`,
    COMPLETED_BY: `完成者`,
    COMPLETED_DATE: `完成日期`,
    COMPLETED_IN_LAST_24_MONTHS: `在过去 24 个月完成`,
    COMPLETION_STATUS: `完成状态`,
    COMPONENT: `部件`,
    COMPONENT_CODE: `部件代码`,
    COMPONENT_CREATED_SUCCESSFULLY: `部件创建成功`,
    COMPONENT_DELETED_SUCCESSFULLY: `部件删除成功`,
    COMPONENT_SERIAL_NUMBER: `部件序列号`,
    COMPONENT_SUCCESSFULLY_UPDATED: `部件更新成功`,
    COMPONENTS: `部件`,
    CONFIRM: `确认`,
    CONFIRM_ADDITIONAL_REPAIR: `是否确定要添加额外维修？`,
    CONFIRM_ADJUST_CLAIM: `是否确定要调整此索赔？`,
    CONFIRM_CLOSING_ACCOUNT: `是否确定要接受此转移？`,
    CONFIRM_COPY_CLAIM: `是否确定要复制此索赔？`,
    CONFIRM_DELETE_ATTACHMENT: `您确定要删除附件吗？`,
    CONFIRM_DELETE_CLAIM: `是否确定要删除此索赔？`,
    CONFIRM_DELETE_MACHINE_STATUS_UPDATE: `是否确实要删除此机器状态请求？`,
    CONFIRM_DELETE_REGISTRATION: `是否确定要删除此注册？`,
    CONFIRM_EDIT_CLAIM: `您要编辑此声明吗？`,
    CONFIRM_RECONCILE_CLAIM: `是否确定要核销此索赔？`,
    CONFIRM_RESEND_XML: `是否确实要重新发送XML?请在24-48小时之间显示。`,
    CONFIRM_SKIP_AUDIT: `您确定要跳过此审核吗？`,
    CONFIRM_UNDO_REGISTRATION: `是否确定要撤消此注册？`,
    CONFIRM_UNRECONCILE_CLAIM: `确定要取消此索赔的对帐吗？`,
    CONNECTED_MACHINE: `连接的机器`,
    CONTACTED: `联系日期`,
    CONTAINS: `包括`,
    CONTRACT_NUMBER: `合同编号`,
    CONTRACT_PURCHASED: `合同购买日期`,
    CONTRACT_TYPE: `合同类型`,
    COPY_CLAIM: `复制索赔`,
    CORE: `核心`,
    CORE_VALUE: `核心值`,
    COUNTRY: `国家`,
    COUNTRY_REQUIRED: `所需国家/地区`,
    COURIER_ACCOUNT_NUMBER: `承运商帐号`,
    COURIER_NAME: `承运商名称`,
    COVERAGE_DECISION: `覆盖范围决定`,
    COVERAGE_TYPE: `覆盖范围类型`,
    CRDMEM: `结算单`,
    CREATE: `创建`,
    CREATE_CLAIM: `创建索赔`,
    CREATE_LAYOUT: `创建布局`,
    CREATE_NON_TRACKED_PIN_HELP_TEXT: `提出有关本产品的索赔前，请提供相关重要信息`,
    CREATE_PIP_CLAIM: `创建 PIP 索赔`,
    CREATE_PIP_CLAIMS: `创建 PIP 索赔`,
    CREATE_PRODUCT_RECORD: `创建产品记录`,
    CREATE_REQUEST: `创建请求`,
    CREATE_TRANSFER_PENDING: `转移待处理`,
    CREATE_TRANSFER_SERVICE_UNAVAILABLE: `创建移交服务不可用`,
    CREATED: `创建`,
    CREATED_BY: `创建人`,
    CREATED_DATE: `创建日期`,
    CREATED_DATE_FROM: `自创建日期`,
    CREATED_DATE_TO: `至创建日期`,
    CREATED_ON: `创建于`,
    CREATION_DATE: `创建日期`,
    CREDIT_MEMO: `结算单`,
    CREDIT_MEMO_DATE: `结算单日期`,
    CREDIT_MEMO_ISSUE_DATE: `结算单发布日期`,
    CREDIT_MEMO_NUMBER: `结算单号`,
    CREDIT_MEMO_PROCESS_DATE: `结算单处理日期`,
    CREDIT_MEMO_SELECTED: `已选结算单`,
    CREDIT_MEMOS: `结算单`,
    CRITERIA: `标准`,
    CRT: `创建`,
    CSV_SEPARATOR: `CSV分隔符`,
    CURRENCY: `货币`,
    CURRENT: `当前`,
    CURRENT_ACCOUNT: `当前帐户`,
    CURRENT_AMOUNT_OF_USE: `当前使用量`,
    CURRENT_CUSTOMER: `当前客户`,
    CURRENT_DEALER: `当前经销商`,
    CURRENT_DEALER_DISTANCE: `当前经销商距离`,
    CURRENT_DEALER_LAST_SERVICE_DATE: `当前交易商上次服务日期`,
    CURRENT_DEALER_LOCATION: `当前经销商地点`,
    CURRENT_HOURS: `当前小时数`,
    CURRENT_QUANTITY: `当前数量`,
    CURRENT_RESPONSIBLE_DEALER: `当前负责的经销商`,
    CURRENT_VALUES: `当前值`,
    CURRENTLY_ON_RENT: `正在租赁`,
    CUSTOM_RANGE: `自定义范围`,
    CUSTOM_VALUES: `自定义值`,
    CUSTOMER: `客户`,
    CUSTOMER_CONTRIBUTION: `客户分摊金额`,
    CUSTOMER_CONTRIBUTION_IS_REQUIRED: `需要填写客户分摊金额`,
    CUSTOMER_CREATED_SUCCESSFULLY: `客户创建成功`,
    CUSTOMER_DETAILS: `客户详情`,
    CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: `客户详细信息更新成功`,
    CUSTOMER_INFORMATION: `客户信息`,
    CUSTOMER_INFORMATION_IS_REQUIRED: `客户信息是必需的。`,
    CUSTOMER_INVALID: `无法找到或创建客户，请搜索客户`,
    CUSTOMER_NAME: `客户名称`,
    CUSTOMER_NAME_IS_REQUIRED: `客户信息是必需的。`,
    CUSTOMER_NOT_FOUND: `客户未找到`,
    CUSTOMER_REQUIRED: `客户必填`,
    CUSTOMER_RESOLUTION: `客户解决方案`,
    CUSTOMER_RESOLUTION_IS_REQUIRED: `需要填写客户解决方案`,
    CUSTOMER_SEARCH: `客户搜索`,
    CUSTOMER_UPDATED_SUCCESSFULLY: `客户更新成功`,
    DAMAGED_MACHINES_HELP_TEXT:`对于损坏的机器，其保修将自动暂停，需等 TCSM 审核、批准本表格完毕之后方可恢复保修。损坏的机器仅有资格参加“强制性 故障与安全”产品改进计划 (PIP)。`,
    DATE: `日期`,
    DATE_FORMAT: `日期格式`,
    DATE_ISSUED: `发布日期`,
    DATE_OF_CERTIFIED_LETTER: `挂号信日期`,
    DATE_OF_EVENT_CAUSING_DAMAGE:`导致机器损坏的事件发生日期`,
    DATE_OF_LAST_PERSONAL_CONTACT: `最后一次联系日期`,
    DATE_RECALLED_PART_WAS_SHIPPED_SENT: `零件发货日期`,
    DATE_REFUSED: `拒绝日期`,
    DATE_SUBMITTED: `提交日期`,
    DAYS_FROM_REGISTRATION: `距离注册的天数`,
    DAYS_LEFT: `剩余天数`,
    DAYS_LEFT_WITH_COUNT: `剩余 {daysToDisplay} 天`,
    DAYS_ON_RENT: `租赁的天数`,
    DAYS_REMAINING: `剩余天数`,
    DAYS_REMAINING_WITH_COUNT: `{daysToDisplay} {days, plural, one {Day} other {Days}} 保留`,
    DAYS_SINCE_RECOMMENDATION: `{daysToDisplay} {days, plural, one {日} other {天数}} 自建议`,
    DAYS_TO_DISPLAY: `要显示的天数`,
    DBS: `经销商业务系统`,
    DEALER: `经销商`,
    DEALER_ACCOUNT: `经销商帐户`,
    DEALER_ACCOUNT_IS_REQUIRED: `需要填写经销商账户`,
    DEALER_ACCOUNTS: `经销商帐户`,
    DEALER_CITY: `经销商城市`,
    DEALER_COMMENTS: `经销商备注`,
    DEALER_CONTRIBUTION: `经销商分摊金额`,
    DEALER_CONTRIBUTION_IS_REQUIRED: `需要填写经销商分摊金额`,
    DEALER_HIERARCHY_ACCOUNT: `{account} ({industryIndicator})`,
    DEALER_INVOICE_NUMBER: `经销商发票号`,
    DEALER_INVOICE_UPDATED: `经销商发票已更新`,
    DEALER_INVOICE_UPDATES: `经销商发票`,
    DEALER_INVOICES: `经销商发票`,
    DEALER_LOCATION: `经销商地点`,
    DEALER_LOCATION_FILTER: `筛选地点`,
    DEALER_LOCATION_IS_REQUIRED: `请选择经销商账号`,
    DEALER_LOCATIONS: `经销商地点`,
    DEALER_NAME: `经销商名称`,
    DEALER_PHONE: `经销商电话号码`,
    DEALER_POSTAL_CODE: `邮政编码`,
    DEALER_RECOMMENDATIONS: `经销商推荐`,
    DEALER_RECOMMENDATIONS_TAB: `经销商建议 ({count})`,
    DEALER_REVIEW_REQUEST_SUCCESSFULLY: `交易商已成功审查`,
    DEALER_SEARCH: `经销商搜索`,
    DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: `输入名称、城市或帐户来搜索经销商`,
    DEALER_STATE: `经销商州/省`,
    DEALER_SUBMISSION_WITH_CURRENCY: `经销商提交 ({currency})`,
    DEALER_TRANSFER_HISTORY: `经销商变更历史`,
    DEALER_TRANSFER_REQUEST_PARTIALLY_SUCCESSFUL: `部分转移请求已成功创建。单独处理。`,
    DEALER_TRANSFER_REQUEST_SUCCESSFULLY: `经销商传输请求已成功排队`,
    DEALER_WARRANTY: `经销商保修`,
    DEALERS: `经销商`,
    DEALERSHIP: `经销商`,
    DEBIT: `扣款`,
    DEBIT_AMOUNT: `扣款金额`,
    DEBIT_FOR_CLAIM_NUMBER: `扣款的索赔单{claimNumber}`,
    DEBIT_REQUIRED: `需扣款`,
    DEBIT_REQUIRED_STATUS: `需扣款状态`,
    DEBIT_SUBMITTED_SUCCESSFULLY: `扣款已成功提交`,
    DEBIT_TYPE: `扣款类型`,
    DEBITED: `扣除`,
    DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: `必需通过手动扣款流程来完成索赔单扣款。`,
    DECIMAL_FORMAT: `十进制格式`,
    DECISION_UPDATED: `更新决定`,
    DECLINE: `拒绝`,
    DEDUCTIBLE: `扣除`,
    DEERE_REMARKS: `Deere 备注`,
    DEFAULT_WARRANTY: `默认保修`,
    DEL: `删除`,
    DELETE: `删除`,
    DELETE_ATTACHMENT: `删除附件`,
    DELETE_CLAIM: `删除索赔`,
    DELETE_MACHINE_STATUS_UPDATE: `删除机器状态更新`,
    DELETE_MACHINE_STATUS_UPDATE_SUCCESS: `机器状态删除成功`,
    DELETE_REGISTRATION: `删除注册`,
    DELETE_REGISTRATION_SUCCESS: `注册成功删除`,
    DELETED: `删除`,
    DELETED_BY: `删除人`,
    DELIVERED: `用户提车日期`,
    DELIVERED_IS_REQUIRED: `需要填写用户提车日期`,
    DELIVERY_DATE: `用户提车日期`,
    DELIVERY_DATE_REQUIRED: `用户提车日期必需`,
    DELIVERY_DATES: `用户提车日期`,
    DELIVERY_NO_DOCUMENTS: `用户已提车，无文档记录`,
    DEMO_RENTAL_BEGIN_DATE: `演示/租赁开始日期`,
    DEMO_RENTAL_CHOOSE_DEALERS_STATUS: `选择经销商和状态`,
    DEMO_RENTAL_END_DATE: `演示/租赁结束日期`,
    DEMO_RENTAL_HISTORY: `演示租赁历史记录`,
    DENY: `拒绝`,
    DENY_AMOUNT_OF_USE: `拒绝使用量`,
    DENY_MACHINE_STATUS_UPDATE: `拒绝机器状态更新`,
    DENY_PIP_CODE_REQUEST: `拒绝 PIP代码申请`,
    DESCENDING: `降序`,
    DESCRIPTION: `描述`,
    DESCRIPTION_OF_DAMAGE:`损坏说明`,
    DESCRIPTION_OF_EVENT_CAUSING_DAMAGE:`导致机器损坏的事件说明`,
    DESELECT_ALL: `取消选择全部`,
    DETAILS: `详情`,
    DIAGNOSTICS_COVERED: `赔付诊断工时`,
    DIS_VSR: `显示消息`,
    DISPLAY: `显示`,
    DISPLAY_CLAIM: `显示索赔`,
    DISPLAY_CREDIT_MEMO: `显示结算单`,
    DISPLAY_FORMAT: `显示格式`,
    DISPLAY_PRODUCT: `显示产品`,
    DISPLAY_TAG: `显示零件返回标签`,
    DISTANCE: `距离`,
    DISTANCE_FROM_CURRENT_DEALER: `与当前经销商的距离`,
    DISTANCE_FROM_POTENTIAL_DEALER: `与潜在交易商的距离`,
    DISTANCE_FROM_RESPONSIBLE_ACCOUNT: `与责任账户的距离`,
    DIVISION: `大区`,
    DIVISION_SUMMARY: `大区总结`,
    DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: `保存所做的更改吗？`,
    DOES_NOT_CONTAIN: `不包括`,
    DOWNLOAD_TO_EXCEL: `下载到 Excel`,
    DOWNTIME: `停机时间`,
    DOWNTIME_IS_REQUIRED: `停产时间必需`,
    DRAFT: `另存为草稿`,
    DTAC_CASE: `DTAC 案例`,
    DTAC_CASE_NUMBER: `DTAC 案例编号`,
    DTAC_SOLUTION: `DTAC 解决方案`,
    DUE_DATE: `到期日期`,
    DUE_WITHIN_3_MONTHS: `3 个月内到期`,
    DUPLICATE_PIN_PLATE: `重复的PIN牌`,
    DUPLICATE_PIN_PLATE_REPORT: `重复的PIN牌报告`,
    DUPLICATE_PIN_PLATE_REQUEST_UPDATED: `PIN牌重复请求已更新`,
    DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: `已成功创建重复的PIN牌请求`,
    DUPLICATE_PIN_PLATE_WITH_COUNT: `重复的PIN牌请求({count})`,
    EDIT: `编辑`,
    EDIT_CUSTOMER: `编辑客户`,
    EDIT_LAYOUT: `编辑布局`,
    EDIT_WITH_PARENTHESES: `(编辑)`,
    EFFECTIVE: `有效`,
    EFFECTIVE_DATE: `生效日期`,
    EMAIL: `电子邮件`,
    EMISSIONS_PART_SEARCH: `排放零件搜索`,
    END_DATE: `结束日期`,
    END_USE: `最终用途`,
    END_USE_CODE: `最终用途代码`,
    END_USE_CODE_REQUIRED: `最终用途代码必填`,
    ENDS_WITH: `结束于`,
    ENGLISH: `英语`,
    ENTER_A_NUMBER_BETWEEN_0_AND_1000: `输入 0 到 1000 之间的数字`,
    ENTER_A_NUMBER_BETWEEN_0_AND_10000: `输入介于 0 与 10000 之间的一个数字`,
    ENTER_A_NUMBER_FROM_1_TO_9999: `输入 1 到 9999 之间的数字`,
    ENTER_A_PART_NUMBER: `输入零件号`,
    ENTER_COMMENTS_BEFORE_ACCEPTING: `接受之前输入注释`,
    ENTITY_ID: `实体Id`,
    EQUALS: `等于`,
    ERROR: `错误：`,
    ERROR_MESSAGE_TITLE: `出现一个错误：`,
    ERROR_MESSAGES: `错误消息`,
    ERROR_MESSAGES_TITLE: `出现多个错误：`,
    ERROR_NETWORK_ISSUES: `一个网络错误阻止了部分数据加载 — 请重试`,
    ERROR_NO_DATA_TO_EXPORT: `无要导出的数据`,
    ERROR_RETRIEVING_CUSTOMER_INFORMATION: `检索客户信息时出错`,
    ERROR_SAP: `无法连接到服务器。如果问题持续存在，请使用“联系我们”链接寻求帮助，以解决相关问题。`,
    ERROR_SESSION: `您的会话已到期。刷新页面以重新登录。`,
    ERROR_UNHANDLED: `系统出现意外错误。如果问题持续存在，请使用我们的“帮助”功能或“联系我们”链接寻求帮助，以解决相关问题。`,
    ERROR_UPLOADING_FILE: `未添加文件`,
    ESTIMATED_BASIC_DATE: `预估基本保修结束日期`,
    ESTIMATED_BASIC_DAYS: `预估基本保修总天数`,
    ESTIMATED_HOURS: `预计工作小时数`,
    ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: `未报告的演示状态和小时数不能反映在在预估结果中`,
    EXCEEDS_DEMO_THRESHOLD: `超出演示阈值`,
    EXCHANGE_RATE: `汇率`,
    EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: `此报告中不包含排除的PIN。`,
    EXECUTE: `执行`,
    EXPAND_ALL: `全部展开`,
    EXPECTED_FIRST_USE: `预计的首次使用日期`,
    EXPIRATION_DATE: `到期日期`,
    EXPIRED: `已过期`,
    EXPIRED_PART_REQUESTS: `过期的零件请求`,
    EXPIRED_PIPS: `到期 PIP`,
    EXPIRES: `到期日期`,
    EXPIRING_SOON: `即将到期`,
    EXPORT: `导出`,
    EXTENDED_WARRANTY: `延长保修`,
    FACTORY: `工厂`,
    FACTORY_DUPLICATE_PIN_PLATE: `重复的PIN牌`,
    FACTORY_NAME: `工厂名称`,
    FACTORY_USERS_TAB: `重复的PIN牌 ({count})`,
    FAILED: `故障日期`,
    FAILED_AREA: `故障部位`,
    FAILED_AREA_IS_REQUIRED: `需要填写故障部位`,
    FAILED_DATE: `故障日期`,
    FAILED_DATE_IS_REQUIRED: `需要填写故障日期`,
    FAILED_MODE: `故障类型`,
    FAILED_MODE_COMMENTS: `故障类型注释`,
    FAILED_PART: `故障部件`,
    FAILED_PART_DESCRIPTION: `故障部件说明`,
    FAILED_PART_IS_A_REMAN_PART: `失败的部分是ReMan部分`,
    FAILED_PART_IS_REQUIRED: `需要填写故障部件`,
    FAILED_PART_SERIAL: `故障部件序列`,
    FAILED_PART_SERIAL_IS_REQUIRED: `需要填写故障部件序号`,
    FAILURE_DATE: `故障日期`,
    FAILURE_INFORMATION: `故障信息`,
    FAILURE_MODE: `故障类型`,
    FAILURE_MODE_IS_REQUIRED: `需要填写故障类型`,
    FAILURE_PART: `故障部件`,
    FAILURE_PART_DESCRIPTION: `故障零件说明`,
    FAILURE_PART_IS_REQUIRED: `故障零件必需`,
    FAILURE_TO_RETURN_PARTS_WARNING: `未能退回所请求的部分可能导致借记。`,
    FAVORITES: `收藏夹`,
    FILE_NAME: `文件名`,
    FILE_SIZE_IS_TOO_BIG: `文件太大（最大容量：100 MB）`,
    FILE_SIZE_IS_TOO_BIG_CSV: `文件太大（最大容量：1 MB）`,
    FILE_UPLOAD_MESSAGE: `将文件拖放到此处或者单击此处以添加文件（最大容量： 100 MB)`,
    FILE_UPLOAD_MESSAGE_CSV: `将文件拖放到此处或者单击此处以添加文件（最大容量： 1 MB)`,
    FILE_UPLOAD_MESSAGE_IMAGE: `在此处拖放图像或单击此处添加图像（最大容量：100 MB)`,
    FILE_UPLOAD_MESSAGE_SINGLE: `将单个文件拖放到此处或单击以添加（最大文件尺寸：100 MB）`,
    FILE_UPLOAD_UNABLE_TO_READ: `系统无法读取您的文件。  请将其与模板进行比较，然后重试。`,
    FILES: `文件`,
    FILTER_DEALER_RECOMMENDATIONS_MESSAGE: `无结果。按Enter搜索所有建议。`,
    FILTER_PLACEHOLDER: `筛选结果`,
    FILTER_WITH_ELLIPSIS: `筛选……`,
    FILTERED_BY_COLUMN_ID: `按 {columnId} 删选`,
    FIND_CUSTOMER: `查找客户`,
    FINNISH: `芬兰语`,
    FIRST_MAINTENANCE: `首次维护`,
    FIRST_NAME: `名`,
    FIRST_NAME_IS_REQUIRED: `需要填写名字`,
    FIRST_SHIP_TO_LOCATION: `第一收货地址`,
    FIRST_USE: `首次使用`,
    FISCAL_YEAR: `财年`,
    FLUID_SAMPLING_REQUIRED: `流体取样必需`,
    FORWARDED: `转发`,
    FRENCH: `法语`,
    FRWRD: `转发`,
    FULL_DEBIT: `全部扣款`,
    GENERAL: `常规`,
    GERMAN: `德语`,
    GET_MAINTENANCE_PLANS: `获取维护计划`,
    GOODS_INSTALLATION_VAT: `货物安装 VAT`,
    GRACE_PERIOD: `宽限期`,
    GREATER_THAN: `大于`,
    GREATER_THAN_OR_EQUALS: `大于等于`,
    GROUP_COMPLETE: `经销商总完成率`,
    GST_PERCENTAGE: `GST 百分比`,
    H_LIMIT: `小时数限制`,
    HISTORY_TO_DISPLAY: `要显示的历史记录（天数）`,
    HOME: `主页`,
    HOUR_LIMIT: `小时数限制`,
    HOURS: `小时数`,
    HOURS_ON_RENT: `租赁小时数`,
    HSN_SAC_CODE: `HSN/SAC 代码`,
    IGST: `IGST`,
    IMPLEMENTS: `农具`,
    IN_RANGE: `区间`,
    INCENTIVE: `激励`,
    INCENTIVE_PROGRAMS: `激励计划`,
    INCLUDE_FULLY_COMPLETE: `包括已完成的PIP`,
    INDICATES_REQUIRED_FIELD: `表示必填字段`,
    INFO_MESSAGE_TITLE: `已发送一个系统通知：`,
    INFO_MESSAGES: `信息性消息`,
    INFO_MESSAGES_TITLE: `已发送多个系统通知：`,
    INFO_REQUEST_STATUS_ERROR: `信息随时可以与此请求一起提交。`,
    INFORMATION: `信息`,
    INFORMATION_REQUEST: `信息请求`,
    INFORMATION_REQUEST_STATUS: `信息请求状态`,
    INPUT_PIN: `输入 PIN`,
    INSPECTION: `检查`,
    INSTALLED_BY: `安装人`,
    INSTALLED_BY_IS_REQUIRED: `需要填写安装人`,
    INTERNAL_DEERE_COMMENTS: `内部 Deere 备注`,
    INTERNAL_EQUIPMENT_NOTES: `内部设备备注`,
    INTERVAL_BEGINS: `间隔开始`,
    INTERVAL_ENDS: `间隔结束`,
    INTERVAL_TYPE_DESCRIPTION: `间隔类型说明`,
    INVOICE_ACCOUNT: `发票账户`,
    INVOICE_DEALER: `发票经销商`,
    INVOICE_NUMBER: `发票号`,
    INVOICE_REQUEST: `发票需求表`,
    INVOICE_SENT: `发票寄送日期`,
    INVOICE_UPDATED_SUCCESSFULLY: `发票已成功更新`,
    INVOICED: `发票日期`,
    INVOICED_TO: `开票对象`,
    IRC_PIN_MESSAGE: `客户是IRC，有权在机器拥有后的第一个500小时或12个月内享受免费差旅时间和里程。`,
    ISSUED: `发布日期`,
    ITALIAN: `意大利语`,
    ITEM: `订单项`,
    ITEM_NUMBER: `附件编号`,
    ITEM_NUMBER_IS_REQUIRED: `需要填写附件编号`,
    JDLINK_EXPIRES: `JDLink 失效`,
    JDP_COMMENTS: `JDP 备注`,
    JDP_COMMENTS_IS_REQUIRED: `需要填写 JDP 备注`,
    JDP_CUSTOMER_RESOLUTION: `JDP 客户解决方案`,
    JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: `需要填写 JDP 客户解决方案`,
    JDP_REASON: `JDP 原因`,
    JDP_REASON_IS_REQUIRED: `需要填写 JDP 原因`,
    LABOR: `人工`,
    LABOR_ADDITIVE: `人工补贴`,
    LABOR_ADDITIVE_COMPLETION_DETAIL: `人工补贴完成率详情`,
    LABOR_ADDITIVE_PIPS: `人工补贴 PIP`,
    LABOR_ADDITIVE_TAB: `人工补贴 ({count})`,
    LABOR_ADJUSTMENT: `人工调整`,
    LABOR_COMMENTS: `人工 备注`,
    LABOR_HOURS: `人工 小时数`,
    LABOR_ITEM_DETAILS: `人工 - {quantity} {unit} {description}`,
    LABOR_RATE_APPROVED_SUCCESSFULLY: `人工费率已成功批准`,
    LABOR_RATE_CHANGE_SUBMITTED: `人工费率更改已提交`,
    LABOR_RATE_CHANGES_WITH_COUNT: `人工费率更改 ({count})`,
    LABOR_RATE_CONFIRM: `请求费率低于当前费率。确认要提交该请求吗？`,
    LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: `红色文本中的施量表示比现有施量增加10%以上`,
    LABOR_RATE_HISTORY: `工时费率历史记录`,
    LABOR_RATE_REJECTED_SUCCESSFULLY: `人工费率已成功拒绝`,
    LABOR_RATE_REQUESTS_STATUS: `人工费率请求状态`,
    LABOR_RATE_RETURNED_SUCCESSFULLY: `人工费率已成功退回`,
    LABOR_RATES: `人工费率`,
    LABOR_STATS: `工时统计`,
    LABOR_TOTAL: `人工合计`,
    LABOR_TYPE: `人工类型`,
    LABOR_VALUE: `人工值`,
    LABOR_WITH_COUNT: `人工 ({count})`,
    LANGUAGE: `语言`,
    LAST_LOCATION_FROM: `最后位置`,
    LAST_NAME: `姓氏`,
    LAST_NAME_IS_REQUIRED: `需要填写姓`,
    LAST_PERSONAL_CONTACT: `最后一次联系`,
    LAST_SEEN: `最后一次看到`,
    LAST_SEEN_AT_RESPONSIBLE_ACCOUNT: `上次在责任帐户上看到`,
    LATEST: `最新`,
    LAW_ENFORCEMENT_AGENCY_DETAILS: `执法机构详细信息`,
    LAYOUT_CREATED_SUCCESSFULLY: `版面已成功创建`,
    LAYOUT_DELETED_SUCCESSFULLY: `布局已成功删除`,
    LAYOUT_NAME: `布局名称`,
    LAYOUT_UPDATED_SUCCESSFULLY: `布局已成功更新`,
    LEAD_ACCOUNT: `总帐户`,
    LEAD_DEALER: `总经销商`,
    LESS_THAN: `小于`,
    LESS_THAN_OR_EQUALS: `小于等于`,
    LICENSE_PLATE_NUMBER: `牌照号`,
    LIFETIME: `终生`,
    LINE_ITEMS_EXPORT: `行项目导出`,
    LIST: `清单`,
    LIST_TOTAL: `清单总计`,
    LOCATION: `地点`,
    LOCATION_DUE: `位置到期`,
    LOCATIONS: `地点`,
    LOCATIONS_WITH_COUNT: `地点 ({count})`,
    MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: `机器已注册到此客户`,
    MACHINE_INFORMATION: `机器信息`,
    MACHINE_MODEL_TYPE: `机器型号/类型`,
    MACHINE_MODEL_TYPE_REQUIRED: `机器型号/型式必填`,
    MACHINE_STATUS: `机器状态`,
    MACHINE_STATUS_UPDATE: `机器状态更新`,
    MACHINE_STATUS_UPDATE_ACCEPTED: `机器状态更新已批准`,
    MACHINE_STATUS_UPDATE_DOCUMENT: `机器状态更新文档`,
    MACHINE_STATUS_UPDATE_REJECTED: `机器状态更新已拒绝`,
    MACHINE_STATUS_UPDATES_WITH_COUNT: `机器状态更新 ({count})`,
    MACHINE_TYPE: `机器类型`,
    MACHINE_TYPE_IS_REQUIRED: `需要填写机器类型`,
    MACHINE_USE: `机器使用量`,
    MAILING_RECIPIENT: `邮寄收件人（名字和姓氏）`,
    MAILING_RECIPIENT_REQUIRED: `需要邮寄收件人`,
    MAINTENANCE: `维护`,
    MAINTENANCE_PLAN: `维护计划`,
    MAINTENANCE_PLAN_INFO: `维护计划信息`,
    MARK_AS_INPROCESS: `标记为进行中`,
    MARK_AS_REVIEW: `标记为已审阅`,
    MARKETING_INCENTIVE: `市场营销 - 激励`,
    MARKETING_JD_PROMISE: `市场营销 - JD Promise`,
    MARKETING_MAINTENANCE_PLAN: `市场营销 - 维护计划`,
    MARKETING_MASS_CHANNEL_FOLLOWUP: `市场营销 - 批量渠道跟进`,
    MARKETING_MASS_CHANNEL_PDI: `市场营销 - 批量渠道 PDI`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP: `批量渠道客户跟进`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: `在此提醒，请确保您在实施售后电话跟进计划之前已联系当地法律顾问确认可以致电客户。`,
    MASS_CHANNEL_PDI_CLAIM: `批量渠道 PDI`,
    MASTER_WARRANTY_TYPE: `主保修类型`,
    MATERIAL: `物料编号`,
    MERCHANDISE: `商品`,
    MESSAGE: `提示信息`,
    MESSAGES: `消息`,
    METHOD_OF_CONTACT: `联系方法`,
    METHOD_OF_CONTACT_IS_REQUIRED: `需要填写联系方法`,
    METRIC: `指标`,
    METRICS: `指标`,
    MILEAGE_LIMIT: `里程限制`,
    MOBILE_PHONE: `移动电话`,
    MODEL: `型号`,
    MODEL_NUMBER: `型号`,
    MODEL_YEAR: `型号年份`,
    MODIFIED: `修改日期`,
    MONTH_TO_DATE: `本月至今`,
    MORE: `更多`,
    MULTIPLE: `多重`,
    NAME: `名称`,
    NET: `净值`,
    NET_AMOUNT: `净值`,
    NET_AMOUNT_PAID: `净赔付值`,
    NET_TOTAL: `净总值`,
    NEW: `新`,
    NEW_ACCOUNT: `新建帐户`,
    NEW_CLAIM: `新索赔`,
    NEW_CLAIM_VALUE: `新索赔值`,
    NEW_CUSTOMER_REQUIRED: `新客户必填`,
    NEW_DEALER: `新经销商`,
    NEW_DEALER_DISTANCE: `新经销商距离`,
    NEW_DEALER_LOCATION: `新经销商地点`,
    NEW_LABOR_RATE: `新人工费率`,
    NEW_REQUEST_ENTER_RATES: `新请求 — 输入施量`,
    NEW_STATUS: `新状态`,
    NEW_TRANSFER: `新移交`,
    NEW_TRANSFER_CREATED: `已创建新移交`,
    NEW_VALUE: `新值`,
    NO: `否`,
    NO_ACTIVE_WARRANTY: `无有效保修`,
    NO_AFFECTED_PINS: `在您的责任范围内，无受影响的 产品`,
    NO_AUTHORITY_TO_ACCESS: `您无权访问JDWS。经销商用户请跟进您的配置文件管理员(DPA)以验证权限，戴尔用户在此处与支持部门联系，并提供此错误的副本`,
    NO_CLAIMS: `无索赔。`,
    NO_CUSTOMER_ASSOCIATED: `无相关联的客户`,
    NO_CUSTOMER_SELECTED: `未选择客户`,
    NO_DEALER_INVOICES: `无经销商发票`,
    NO_DEALERS_MAPPED: `还未有经销商和您的用户名相关联。 请与系统管理员联系。`,
    NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE:`不能（如果不能，必须提供照片作为证据）`,
    NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: `没有该产品的信息。`,
    NO_LABOR_COVERAGE: `无人工保险`,
    NO_LOWERCASE: `无`,
    NO_MATCHING_DEALERS: `没有经销商符合筛选条件。`,
    NO_OPEN_PART_REQUESTS: `没有公开部件请求`,
    NO_OPEN_PIPS: `无未结 PIP`,
    NO_PARTS_RETURNED: `没有返回零件`,
    NO_PIP_PRODUCTS: `没有此类 PIP 产品。`,
    NO_PRODUCT_FOUND: `未找到产品`,
    NO_REQUIRED_ITEMS: `无必需项目。`,
    NO_RESULTS: `无结果`,
    NO_RESULTS_FOUND: `未找到结果`,
    NO_ROWS_TO_SHOW: `无结果可显示`,
    NO_SPECIAL_INSTRUCTIONS: `无特殊说明。`,
    NO_TRAVEL: `无差旅`,
    NON_RECOVERABLE_TAXES: `不可抵扣税`,
    NON_TRACKED_PINS_HELP_TEXT: `有些产品只有注册后才会出现在保修系统内。您的搜索和此类产品相匹配。`,
    NON_TRAVEL: `非差旅`,
    NONE: `无`,
    NORMAL: `正常`,
    NOT_EQUAL: `不等于`,
    NOTIFICATION_ADDED_SUCCESSFULLY:`通知已成功添加`,
    NOTIFICATION_DELETED_SUCCESSFULLY:`通知已成功删除`,
    NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: `通知顺序已成功更新`,
    NOTIFICATION_UPDATED_SUCCESSFULLY:`通知已成功更新`,
    NOTIFICATIONS: `通知`,
    NUMBER_OF_DIAGNOSTICS_OCCURRENCES: `诊断发生次数`,
    NUMBER_OF_OPEN_PIPS: `{number} 未结 PIP`,
    NUMBER_OF_REPAIR_OCCURRENCES: `维修发生次数`,
    NUMBER_OF_REPLACEMENT_OCCURRENCES: `更换发生次数`,
    OLD_LABOR_RATE: `以前的人工费率`,
    ON_SHELF: `上架`,
    ON_SHELF_COST: `上架成本`,
    ONE_ITEM_MUST_BE_SELECTED: `必须选择一个项目`,
    OPEN: `未结`,
    OPEN_PART_REQUESTS: `未处理零件请求`,
    OPEN_PART_REQUESTS_WITH_COUNT: `未处理零件请求 ({count})`,
    OPEN_PIP_COUNT: `打开PIP计数`,
    OPEN_PIP_PROGRAMS: `PIP 登记`,
    OPEN_PIPS: `未结 PIP`,
    OPEN_PIPS_REPORT: `未完成PIP报告`,
    OPEN_PIPS_TAB: `未结 PIP ({count})`,
    OPEN_PIPS_Y_N: `未结PIP(Y/N)`,
    OPERATORS_COMPLAINT: `操作员抱怨了什么问题？`,
    OPERATORS_COMPLAINT_IS_REQUIRED: `必需填写操作员抱怨的问题`,
    OPERATORS_MANUAL_NUMBER: `操作手册号`,
    OPTION_CODE: `选配代码`,
    OPTION_CODE_CREATED_SUCCESSFULLY: `选配代码创建成功`,
    OPTION_CODE_DELETED_SUCCESSFULLY: `选配代码删除成功`,
    OPTION_CODES: `选配代码`,
    OR: `或`,
    ORIGINAL_CLAIM_VALUE: `原始索赔值`,
    ORIGINAL_SUBMISSION_DATE: `首次提交日期`,
    ORIGINALLY_SUBMITTED: `首次提交日期`,
    OTHER: `其他`,
    OTHER_AMOUNT_OF_USE: `其他使用量`,
    OTHER_AMOUNT_OF_USE_REQUIRED: `其他使用量必填`,
    OTHER_CREDIT: `其他赔付`,
    OTHER_CREDIT_1: `其他赔付 1`,
    OTHER_CREDIT_2: `其他赔付 2`,
    OTHER_CREDIT_3: `其他赔付 3`,
    OTHER_CREDIT_ADJUSTMENT: `其他贷项调整`,
    OTHER_CREDIT_ITEM_DETAILS: `其他赔付 - {description} ({quantity} {unit})`,
    OTHER_CREDIT_TOTAL: `其他赔付总计`,
    OTHER_CREDITS: `其他赔付`,
    OTHER_CREDITS_WITH_COUNT: `其他赔付 ({count})`,
    OTHER_INSTRUCTIONS: `其他说明`,
    OUTPUT_PIN: `输出 PIN`,
    OVERDUE: `过期`,
    OVERRIDE_ACCOUNT: `覆盖帐户`,
    OVERRIDE_EFFECTIVE_DATE: `替代生效日期`,
    OVERRIDE_SUGGESTED_ACCOUNT: `超控建议的帐户`,
    OWNERSHIP_STATUS: `所有权状态`,
    OWNERSHIP_STATUS_IS_REQUIRED: `需要填写所有权状态`,
    PART: `零件`,
    PART_1: `零件 1`,
    PART_2: `零件 2`,
    PART_3: `零件 3`,
    PART_4: `零件 4`,
    PART_5: `零件 5`,
    PART_6: `零件 6`,
    PART_7: `零件 7`,
    PART_8: `零件 8`,
    PART_9: `零件 9`,
    PART_10: `零件 10`,
    PART_AMONT_OF_USE: `零件使用时间`,
    PART_FAMILY: `零件所属产品系列`,
    PART_ITEM_DETAILS: `零件 - {quantity} {description} 零件编号 {partNumber}`,
    PART_NUMBER: `零件号`,
    PART_REQUEST: `零件请求`,
    PART_REQUEST_NUMBER: `零件请求 {rgaNumber}`,
    PART_REQUEST_STATUS: `零件请求状态`,
    PART_REQUESTS: `零件请求`,
    PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: `输入索赔号，最少 4 个字符`,
    PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: `索赔搜索必须至少为 4 个字符`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: `DTAC 案例编号搜索必须为完整的 DTAC 案例编号，长度至少为 4 个字符`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: `输入完整的 DTAC 案例编号`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: `零件号搜索必须至少为 4 个字符`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: `输入零件号，最少 4 个字符`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: `零件请求编号搜索必须至少为 4 个字符`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: `输入零件请求编号，最少 4 个字符`,
    PART_REQUESTS_SEARCH_BY_PIN_ERROR: `PIN 搜索必须至少为 4 个字符`,
    PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: `输入 PIN，最少 4 个字符`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: `工单搜索必须为完整的工单号，至少为 2 个字符`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: `输入完整工单号`,
    PART_REQUESTS_UPDATED_SUCCESSFULLY: `零件请求更新成功`,
    PART_RETURN: `零件返回`,
    PART_RETURNS: `零件返回`,
    PART_SERIAL_NUMBER: `零件序列号`,
    PART_SERIAL_NUMBER_IS_REQUIRED: `需要填写零件序列号`,
    PART_TOTAL: `零件总计`,
    PART_TYPE: `零件类型`,
    PART_USE: `零件使用时间`,
    PART_VALUE: `零件值`,
    PARTIAL_DEBIT: `部分扣款`,
    PARTICIPANT: `参与者`,
    PARTS: `零件`,
    PARTS_ADDITIVE: `零件补贴`,
    PARTS_ADJUSTMENT:`零件调整`,
    PARTS_COVERAGE_SEARCH: `部件覆盖范围搜索`,
    PARTS_TEMPLATE: `零件模板`,
    PARTS_USE: `零件使用时间`,
    PARTS_USE_IS_REQUIRED: `需要填写零件使用时间`,
    PARTS_WITH_COUNT: `零件 ({count})`,
    PARTS_WITH_PARENTHESES: `零件`,
    PAST_DUE: `过期`,
    PAYER_ACCOUNT: `付款人帐户`,
    PC_LIMIT:`草捆限制`,
    PERCENT_COMPLETE: `百分比完成`,
    PERCENTAGE: `百分比`,
    PERCENTAGE_DEBIT: `借记百分比`,
    PERCENTAGE_SYMBOL: `{percentage}%`,
    PERCENTAGE_TO_DEBIT: `借记百分比`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT:`对于损坏的机器，其保修将自动暂停，需等 TCSM 审核、批准本表格完毕之后方可恢复保修。损坏的机器仅有资格参加“强制性 故障与安全”产品改进计划 (PIP)。`,
    PERSON_RESPONSIBLE: `负责人`,
    PHONE: `电话`,
    PHONE_REQUIRED: `电话必填`,
    PICTURE: `图片`,
    PICTURE_REQUEST: `图片请求`,
    PICTURE_REQUEST_STATUS: `图片请求状态`,
    PICTURE_REQUEST_STATUS_ERROR: `附件随时可以与此请求一起提交。`,
    PIN: `PIN`,
    PIN_CREATED_SUCCESSFULLY: `PIN 已成功创建`,
    PIN_CROSS_REFERENCE: `序列号转换查询`,
    PIN_INVALID: `PIN 无效`,
    PIN_IS_REQUIRED: `PIN 必需`,
    PIN_REQUIRED: `PIN 必填`,
    PIN_SEARCH: `PIN搜索`,
    PIN_SEARCH_INFORMATION: `PIN搜索信息`,
    PIN_TRANSFER_INFORMATION: `插脚转移信息`,
    PINS: `PIN`,
    PINS_NOT_REGISTERED: `未注册的产品`,
    PIP: `PIP`,
    PIP_CODE: `PIP 代码`,
    PIP_CODE_CREATED_SUCCESSFULLY: `PIP 代码申请创建成功`,
    PIP_CODE_REQUEST: `PIP 代码申请`,
    PIP_CODE_REQUEST_APPROVED: `PIP 代码申请已批准`,
    PIP_CODE_REQUEST_REJECTED: `PIP 代码申请已拒绝`,
    PIP_CODE_REQUESTS_WITH_COUNT: `PIP 代码申请 ({count})`,
    PIP_COMPLETION_STATUS: `PIP 完成状态`,
    PIP_DETAILS: `PIP 详细信息`,
    PIP_HISTORY: `PIP 历史记录`,
    PIP_ID: `PIP 编号`,
    PIP_NUMBER: `PIP 号`,
    PIP_PROGRAM: `PIP 项目`,
    PIP_PROGRAM_IS_REQUIRED: `需要填写 PIP 项目`,
    PIP_PROGRAMS: `PIP 项目`,
    PIP_SEARCH: `PIP 搜索`,
    PIP_STATUS: `PIP 状态`,
    PIP_TYPE: `PIP 类型`,
    PIP_TYPES: `PIP 类型`,
    PIPS: `PIP`,
    PIPS_UNPAID_LABOR_ADDITIVE: `PIP 未赔付的人工补贴`,
    PLAN_DESCRIPTION: `计划说明`,
    PLAN_END_DATE: `计划结束日期`,
    PLAN_ENDS: `计划结束`,
    PLAN_NAME: `计划名称`,
    PLAN_NAME_IS_REQUIRED: `需要填写计划名称`,
    PLAN_NAMES: `计划名称`,
    PLAN_START_DATE: `计划开始日期`,
    PLAN_STARTS: `计划开始`,
    PLANNED_BY: `计划人`,
    PLANT: `工厂`,
    PLATE_REQUEST_INFORMATION: `牌照请求信息`,
    PLEASE_SELECT_A_LEAD_ACCOUNT: `请选择一个总账户`,
    PLEASE_SELECT_CLAIM_TYPE: `请选择索赔类型`,
    POLISH: `波兰语`,
    PORTUGUESE: `葡萄牙语`,
    POSTAGE_DELIVERY_DATE: `邮件送达日期`,
    POSTAL_CODE: `邮政编码`,
    POSTAL_CODE_REQUIRED: `邮政编码必填`,
    POSTAL_TRACKING_NUMBER: `邮政追踪编号`,
    POTENTIAL_RESPONSIBLE_DEALER: `潜在负责的经销商`,
    PRE_DELIVERY_INSPECTION: `交车前检查`,
    PREFERRED_THEME: `首选主题`,
    PREPARE_AUDIT: `准备审计`,
    PREPARED: `准备日期`,
    PREPARING_AUDIT_FOR_WITH_DEALER: `准备 {dealer} 的审计`,
    PREVIOUS_AMOUNT_OF_USE: `先前使用量`,
    PREVIOUS_INVOICE_NUMBER: `先前发票号`,
    PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: `需要填写先前发票号`,
    PREVIOUS_MONTH: `上个月`,
    PRICE: `价格`,
    PRICING_SUMMARY: `定价汇总`,
    PRIMARY_ACTION: `主要操作`,
    PRIMARY_LANGUAGE: `主要语言`,
    PRINT: `打印`,
    PRINT_CLAIM: `打印索赔`,
    PRINT_REGISTRATION_FORM: `打印注册表格`,
    PRINT_REGISTRATION_FORM_MESSAGE: `产品已注册给首个所有者。您想现在打印注册表格吗？`,
    PRINT_TO_PDF: `打印`,
    PRIORITY: `优先级`,
    PRNT_CLM: `显示索赔`,
    PROCESS_DATE: `处理日期`,
    PROCESSED: `处理日期`,
    PROCESSED_PART_REQUESTS: `已处理的零件请求`,
    PROCESSING_STATUS: `处理状态`,
    PROCESSING_STATUS_DESCRIPTION: `处理状态说明`,
    PRODUCT_DETAILS: `产品详细信息`,
    PRODUCT_HIERARCHY: `产品层级`,
    PRODUCT_INFORMATION: `产品信息`,
    PRODUCT_REGISTERED: `产品已注册`,
    PRODUCT_REGISTRATION: `产品注册`,
    PRODUCT_REGISTRATION_PENDED: `产品注册被待定`,
    PRODUCT_TRACKING: `产品跟踪`,
    PRODUCTS: `产品`,
    PRODUCTS_BY_CUSTOMER: `按客户过滤产品`,
    PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: `由于临时系统连接问题，过去的PIN可能会在搜索结果中丢失`,
    PRODUCTS_WITH_COUNT: `产品 ({count})`,
    PROGRAM: `程序`,
    PROGRAM_DESCRIPTION: `程序说明`,
    PROGRAM_IS_REQUIRED: `程序名称是必需的。`,
    PROGRAM_NAME: `程序名称`,
    PROGRAM_NAME_IS_REQUIRED: `程序名称是必需的。`,
    PROGRAM_NUMBER: `计划编号`,
    PRT: `产品跟踪`,
    PRTS: `产品跟踪`,
    PURCHASE_INFO: `采购信息`,
    PURCHASE_ORDER: `购货订单号`,
    PURCHASE_ORDER_IS_REQUIRED: `需要填写购货订单号`,
    PURCHASER_TYPE: `购买者类型`,
    PURCHASER_TYPE_REQUIRED: `购买者类型必填`,
    PUSH_XML: `重新发送XML`,
    QTY: `数量`,
    QUALIFY_FOR_EMISSIONS: `符合排放条件`,
    QUANTITY: `数量`,
    QUANTITY_1: `数量 1`,
    QUANTITY_2: `数量 2`,
    QUANTITY_3: `数量 3`,
    QUANTITY_4: `数量 4`,
    QUANTITY_5: `数量 5`,
    QUANTITY_6: `数量 6`,
    QUANTITY_7: `数量 7`,
    QUANTITY_8: `数量 8`,
    QUANTITY_9: `数量 9`,
    QUANTITY_10: `数量 10`,
    QUERY_MUST_CONTAIN_3_CHARACTERS: `查询必须包含至少 3 个字符`,
    QUEST_DESC: `可疑描述`,
    QUESTIONABLE_PART: `有问题的零件`,
    QUEUED: `排队`,
    READING_DATE: `读取日期`,
    REASON: `原因`,
    REASON_EVENT_NUMBER: `原因事件编号`,
    REASON_FOR_CHANGE: `更改原因`,
    REASON_FOR_DEBIT: `扣款原因`,
    REASON_FOR_MISSING_PLATE: `板缺失的原因`,
    REASON_FOR_MISSING_PLATE_REQUIRED: `需要板缺失的原因`,
    REASON_FOR_OVERRIDE: `替代原因`,
    REASON_FOR_REFUSAL: `拒绝原因`,
    REASON_FOR_RETURN: `退货原因`,
    REASON_FOR_RETURN_IS_REQUIRED: `需要填写退货原因`,
    REASON_FOR_TRANSFER: `移交原因`,
    REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: `移交原因必须包含字母数字字符`,
    REASON_FOR_TRANSFER_REJECTION: `转移拒绝原因`,
    RECIPIENT_DEALER_OR_TCSM: `收件人（经销商或TCSM）`,
    RECIPIENT_MAILING: `邮寄收件人`,
    RECOMMENDATION: `建议`,
    RECOMMENDATION_DATE: `建议日期`,
    RECOMMENDED_ACCOUNT: `推荐帐户`,
    RECONCILE: `核销`,
    RECONCILE_CLAIM: `核销索赔`,
    RECONCILED: `核销`,
    RECORD_AUDIT: `记录审计`,
    RECORD_AUDIT_FOR: `记录 {dealer} 的审计`,
    RECORDS_FOUND: `找到 {countToDisplay} 条记录`,
    RECOVERABLE_TAXES: `可抵扣税`,
    RECOVERED: `赔付比率`,
    RECOVERED_WITH_MISSED_ADDITIVES: `含补贴损失的赔付比率`,
    RECOVERED_WITHOUT_ADDITIVES: `不含补贴的赔付比率`,
    RECOVERY: `赔付情况`,
    RED_MUST_BE_LESS_THAN_YELLOW: `红色指示灯数值必须小于黄色指示灯数值`,
    REFERENCE_1: `参考 1`,
    REFERENCE_2: `参考 2`,
    REFERENCE_INFORMATION: `参考信息`,
    REFERENCE_NUMBER1: `参考号 1`,
    REFERENCE_NUMBER2: `参考号 2`,
    REGION: `地区`,
    REGISTER: `注册`,
    REGISTER_A_PRODUCT_BY_PIN: `通过 PIN 注册产品`,
    REGISTER_A_PRODUCT_TO_ADD: `注册产品并添加到索赔系统`,
    REGISTER_ANOTHER_PRODUCT: `注册另一个产品`,
    REGISTER_PRODUCT: `注册产品`,
    REGISTER_PRODUCT_AND_REGISTER_ANOTHER: `注册产品并注册下一个`,
    REGISTERED: `注册日期`,
    REGISTRATION: `注册`,
    REGISTRATION_DATE: `注册日期`,
    REGISTRATION_DATES: `登记日期`,
    REGISTRATION_FORM: `注册表`,
    REGISTRATION_HISTORY: `注册历史记录`,
    REGISTRATION_NOT_ALLOWED: `该产品不允许注册`,
    REGISTRATION_REVIEW: `注册检查`,
    REGISTRATION_REVIEW_TAB: `注册检查 ({count})`,
    REGISTRATION_STATUS: `注册状态`,
    REGISTRATION_STATUS_CANNOT_BE_NEW: `注册状态不能为新`,
    REGISTRATION_STATUS_REQUIRED: `注册状态必需`,
    REGISTRATION_SUCCESS: `注册成功`,
    REGISTRATION_TYPE: `注册类型`,
    REGISTRATION_TYPE_CANNOT_BE_NEW: `注册类型不能为新`,
    REGISTRATION_TYPE_REQUIRED: `注册类型必填`,
    REGISTRATION_UPDATED_SUCCESSFULLY: `注册更新成功`,
    REGISTRATIONS_REVIEW: `注册检查`,
    REIMBURSED: `赔付`,
    REIMBURSED_AMOUNT: `赔付金额`,
    REIMBURSED_PERCENTAGE: `赔付百分比`,
    REIMBURSED_PERCENTAGE_INDICATOR: `赔付百分比指示灯`,
    REIMBURSEMENT_DETAILS: `赔付详细信息`,
    REIMBURSEMENT_PERCENTAGE: `赔付百分比`,
    REIMBURSEMENT_SUMMARY: `赔付总结`,
    REJECT: `拒绝`,
    REJECT_LABOR_RATE: `拒绝人工费率`,
    REJECT_SPECIAL_ALLOWANCE_CLAIM: `拒绝特殊索赔`,
    REJECTED: `拒绝`,
    REJECTED_APPEAL: `被拒请求`,
    RELATIONSHIP: `关系`,
    RELATIONSHIP_IS_REQUIRED: `需要填写关系`,
    REMOVE_FILTER: `取消筛选`,
    REMOVE_FROM_AUDIT: `从审计中删除`,
    REMOVE_LAYOUT: `删除布局`,
    RENTAL_PINS: `租赁PIN`,
    REPAIR_DATE: `维修日期`,
    REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: `维修日期不可早于故障日期`,
    REPAIR_NUMBER: `修理号`,
    REPAIR_NUMBER_IS_REQUIRED: `需要填写修理号`,
    REPAIR_REPLACE_INDICATOR: `修理/更换分类`,
    REPAIRED: `维修日期`,
    REPAIRED_DATE: `维修日期`,
    REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: `维修日期不可早于故障日期`,
    REPAIRED_DATE_IS_REQUIRED: `需要填写维修日期`,
    REPORT_DATE: `报告日期`,
    REPORT_NUMBER: `报告号`,
    REPORTS: `报告`,
    REQ_ADDL: `调整结算`,
    REQUEST: `请求`,
    REQUEST_DATE: `请求日期`,
    REQUEST_DETAILS: `请求详情`,
    REQUEST_DUPLICATE_PIN_PLATE: `请求复制PIN牌`,
    REQUEST_FORM: `申请表`,
    REQUEST_PIP_CODE: `申请 PIP 代码`,
    REQUEST_STATUS: `请求状态`,
    REQUEST_SUBMITTED: `申请已提交`,
    REQUEST_TYPE: `请求类型`,
    REQUEST_UPDATED_SUCCESSFULLY: `请求已成功更新`,
    REQUEST_WARRANTY_CLAIM_DEBIT: `申请索赔扣款`,
    REQUESTED: `申请值`,
    REQUESTED_BY: `申请人`,
    REQUESTED_DATE: `申请日期`,
    REQUESTED_DATES: `申请日期`,
    REQUESTED_DIAGNOSTIC_AMOUNT: `请求的诊断金额`,
    REQUESTED_DIAGNOSTIC_HOURS: `请求的诊断时间`,
    REQUESTED_LABOR_AMOUNT: `申请的工时数`,
    REQUESTED_LABOR_HOURS: `申请的工时`,
    REQUESTED_OTHER_CREDITS: `申请的其他赔付`,
    REQUESTED_PARTS: `申请的零件金额`,
    REQUESTED_REPAIR_AMOUNT: `请求的修理金额`,
    REQUESTED_REPAIR_HOURS: `请求的维修时间`,
    REQUESTED_TRAVEL_TOTAL: `申请的差旅总计`,
    REQUESTER_TCSM: `申请人(TCSM)`,
    REQUESTER_TCSM_REQUIRED: `需要申请人(TCSM)`,
    REQUIRED: `必需`,
    REQUIRED_CRITERIA: `必填标准`,
    REQUIRED_ITEMS: `必需项目`,
    RESEND_XML: `重新发送XML`,
    RESET: `重置`,
    RESPONDENT_INFORMATION: `回复信息`,
    RESPONSIBILITY_OF: `职责`,
    RESPONSIBLE_ACCOUNT: `责任账户`,
    RESPONSIBLE_ACCOUNT_IS_REQUIRED: `责任账户必需`,
    RESPONSIBLE_DEALER: `负责经销商`,
    RESPONSIBLE_DEALER_REPORT_RECORDS_COUNT_WARNING: `显示前100个结果。下载以获得完整的结果`,
    RET: `退回`,
    RETAIL_INSTALL: `零售/安装日期`,
    RETAIL_INSTALL_DATE: `零售/安装日期`,
    RETAIL_INSTALL_IS_REQUIRED: `需要填写零售/安装日期`,
    RETAILER_NAME: `零售商名称`,
    RETAILER_NAME_IS_REQUIRED: `需要填写零售商名称`,
    RETRY: `重试`,
    RETURN: `返回`,
    RETURN_LABOR_RATE: `返回人工费率`,
    RETURN_REQUEST: `退货申请`,
    RETURN_SPECIAL_ALLOWANCE_CLAIM: `退回特殊索赔`,
    RETURN_STATUS: `返回状态`,
    RETURNED: `退回`,
    RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: `退货日期不可早于用户提车日期`,
    RETURNED_DATE_IS_REQUIRED: `需要填写退货日期`,
    RETURNED_MACHINE_STATUS_UPDATE: `返回的机器状态更新`,
    REVIEW_DEALER_RECOMMENDATIONS: `确定要标记PIN以供查看？`,
    REVISE: `修订`,
    REVISED: `修订`,
    ROLLING_12_CREDIT_AMOUNT: `累计12 个月赔付额`,
    ROLLING_12_MONTHS: `累计 12 个月`,
    RUN_REPORT: `运行报告`,
    RUSSIAN: `俄语`,
    SAP_DOWN_WARNING: `保修系统功能已损坏。我们正在努力尽快纠正这一情况。刷新浏览器以检查系统可用性。`,
    SAVE: `保存`,
    SAVE_AS_DRAFT: `另存为草稿`,
    SAVE_AS_NEW_LAYOUT: `另存为新布局`,
    SAVE_AUDIT: `保存审计`,
    SAVE_CHANGES: `保存更改`,
    SAVE_TO_VALIDATE: `保存以验证`,
    SAVE_VALD: `保存并确认`,
    SAVE_VALIDATE: `保存并确认`,
    SEARCH: `搜索`,
    SEARCH_BOX_PLACEHOLDER: `输入 PIN、序列号、索赔编号、DTAC 案例或客户姓名`,
    SEARCH_BY_CLAIM_TYPE: `输入完整的索赔类型`,
    SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: `索赔搜索必须为完整的索赔类型，字符数介于 4 到 9 之间`,
    SEARCH_BY_FAILURE_PART_NUMBER: `输入完整的故障部件号`,
    SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: `索赔搜索必须为完整的索赔类型，最少为 4 个字符`,
    SEARCH_BY_WORK_ORDER: `输入工作通知单，最少为 2 个字符`,
    SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: `工单搜索必须是2个字符`,
    SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: `输入完整索赔编号`,
    SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: `必须通过 4 至 9 个字符的完整索赔编号来搜索索赔`,
    SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: `输入完整部件序列号`,
    SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: `部件搜索必须填写完整序列号，至少含 1 个字符`,
    SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: `输入PIN`,
    SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: `输入完整型号`,
    SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: `必须通过 3 至 12 个字符的完整型号来搜索型号`,
    SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: `输入 PIN，最少为 6 个字符`,
    SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: `PIN 搜索字符数必须介于 6 到 17 之间`,
    SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: `输入 PIP 号，最少 4 个字符`,
    SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: `PIP 搜索必须是 4 到 12 个字符`,
    SEARCH_RESULTS_TAB: `搜索结果 ({count})`,
    SECOND_SHIP_TO_LOCATION: `第二收货地址`,
    SELECT: `选择`,
    SELECT_A_RANGE: `选择范围`,
    SELECT_ALL: `全选`,
    SELECT_AUTO_SUBMIT: `选择自动提交`,
    SELECT_BRANCH: `选择分支机构`,
    SELECT_CLAIM_TYPE: `选择索赔类型`,
    SELECT_COLUMNS: `选择列`,
    SELECT_COUNTRY: `选择国家`,
    SELECT_CSV_SEPARATOR: `选择CSV分隔符`,
    SELECT_DATE_FORMAT: `选择日期格式`,
    SELECT_DEALERS_AND_STATUS: `选择经销商和状态`,
    SELECT_DECIMAL_FORMAT: `选择十进制格式`,
    SELECT_DISPLAY_FORMAT: `选择显示格式`,
    SELECT_FACTORY: `选择工厂`,
    SELECT_LANGUAGE: `选择语言`,
    SELECT_LAYOUT: `选择布局`,
    SELECT_PIP_CODE: `选择 PIP 代码`,
    SELECT_PLAN_NAMES: `选择计划名称`,
    SELECT_SERVICE_INTERVAL_TYPES: `选择服务间隔类型`,
    SELECT_SORT_BY: `选择排序`,
    SELECT_SORT_DIRECTION: `选择排序顺序`,
    SELECT_STATE: `选择省市`,
    SELECT_STATUS: `选择状态`,
    SELECT_TERRITORY: `选择地区`,
    SELECT_THEME: `选择主题`,
    SELECT_TIME_ZONE: `选择时区`,
    SELECT_VALUES_TO_APPROVE: `选择要批准的数值`,
    SELECTED_COLUMNS: `选定的列`,
    SELECTED_FOR_AUDIT: `选择用于审计`,
    SELECTED_FOR_AUDIT_VSR: `关于此索赔所需的审计文档和附件，请参见DTAC解决方案221475`,
    SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: `选择多个帐户和保修类型影响系统响应速度`,
    SEND: `发送`,
    SERIAL_NUMBER: `序列号`,
    SERIAL_NUMBER_INVOICE_NUMBER: `序列号 / 发票号`,
    SERVER_TOOK_TOO_LONG_TO_REPLY: `服务器等待时间过长，请求已被取消。请输入更具体的请求或稍后重试。`,
    SERVICE_DATE_IS_REQUIRED: `需要服务日期`,
    SERVICE_INTERVAL: `服务间隔`,
    SERVICE_INTERVAL_BEGIN_DATE: `服务间隔开始日期`,
    SERVICE_INTERVAL_END_DATE: `服务间隔结束日期`,
    SERVICE_INTERVAL_IS_REQUIRED: `需要填写服务间隔`,
    SERVICE_INTERVAL_NUMBER: `服务间隔号`,
    SERVICE_INTERVAL_STATUS: `服务间隔状态`,
    SERVICE_INTERVAL_TYPE: `服务间隔类型`,
    SERVICE_INTERVAL_TYPES: `服务间隔类型`,
    SERVICE_PART: `服务零件`,
    SERVICE_UNAVAILABLE: `服务不可用`,
    SERVICED: `服务日期`,
    SERVICED_DATE_IS_REQUIRED: `服务日期是必需的。`,
    SERVICED_IS_REQUIRED: `服务日期是必需的。`,
    SET_AS_DEFAULT: `设为默认`,
    SETTINGS: `个人设置`,
    SETTLED: `结算日期`,
    SETTLEMENT_NO_REGISTRATION: `已结算，未注册`,
    SETUP: `设置`,
    SETUP_DATE_IS_REQUIRED: `需要填写设置日期`,
    SETUP_IS_REQUIRED: `需要填写设置日期`,
    SGST_UTGST: `SGST/UTGST`,
    SHIP_TO: `收货方`,
    SHIPPED: `发货日期`,
    SHIPPING_ID: `装运ID`,
    SHIPPING_ID_REQUIRED: `需要装运ID`,
    SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: `发货信息/特殊说明`,
    SHIPPING_INSTRUCTIONS: `发货说明`,
    SHORT_TEXT: `短 文本`,
    SHORT_TEXT_IS_REQUIRED: `需要短文字`,
    SHOW_ALL: `显示所有 ({count})`,
    SHOW_EXCLUDED: `显示除外PIP`,
    SHOW_MORE: `显示更多`,
    SHOW_MORE_GROUPS: `再显示 {countToDisplay} 组`,
    SHOW_RED_IF_LESS_THAN: `小于以下值则显示红色`,
    SHOW_REIMBURSED_AMOUNT: `显示赔付金额`,
    SHOW_REIMBURSED_PERCENTAGE: `显示赔付百分比`,
    SHOW_YELLOW_IF_LESS_THAN: `小于以下值则显示黄色`,
    SIGN_IN_REQUIRED: `登录`,
    SIGN_OUT: `登出`,
    SKIP_AUDIT: `跳过审核`,
    SKIP_AUDIT_SUCCESS: `已跳过审核，到期日将在将来`,
    SOME_PARTS_RETURNED: `某些零件退回`,
    SORT_BY: `排序方式`,
    SPANISH: `西班牙语`,
    SPECIAL_ALLOWANCE: `特殊索赔`,
    SPECIAL_ALLOWANCE_CALCULATION: `特殊索赔计算`,
    SPECIAL_ALLOWANCE_CLAIM: `特殊索赔申请`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS: `特殊索赔状态`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: `特殊索赔状态`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: `特殊索赔状态已更新`,
    SPECIAL_ALLOWANCE_CLAIM_WITH_ID: `特殊索赔 - {claimNumber}`,
    SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: `特殊索赔 ({count})`,
    SPECIAL_ALLOWANCE_CONTRIBUTIONS: `特殊索赔分摊金额`,
    SPECIAL_ALLOWANCE_DESCRIPTION: `特殊索赔说明`,
    SPECIAL_ALLOWANCE_TYPE: `特殊索赔类型`,
    SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: `需要填写特殊索赔类型`,
    SPECIAL_INSTRUCTIONS: `特殊说明`,
    SPG: `SPG`,
    SPGS: `SPG`,
    STANDARD_VIEW: `标准视图`,
    START_AMOUNT_OF_USE: `开始使用量`,
    STARTS: `开始`,
    STARTS_WITH: `开始于`,
    STATE: `省份`,
    STATE_PROVINCE: `州/省`,
    STATE_PROVINCE_REQUIRED: `要求的州/省`,
    STATUS: `状态`,
    STATUS_CHANGE_REQUEST: `状态变更申请`,
    STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: `状态变更申请创建成功`,
    STATUS_CHANGE_REQUEST_UPDATED_SUCCESSFULLY: `机器状态请求更新成功`,
    STATUS_FOR: `{pin} 的状态`,
    STATUS_INDICATOR: `机器交付时状态`,
    STATUS_REASON: `状态原因`,
    STOLEN_DATE: `被盗日期`,
    STORE: `门店号`,
    STORE_IS_REQUIRED: `需要填写门店号`,
    STORE_NUMBER_IS_REQUIRED: `需要填写门店号`,
    STREET_1: `街道 1`,
    STREET_2: `街道 2`,
    SUB: `提交`,
    SUB_CLAIM_TYPE: `子索赔类型`,
    SUB_TYPE: `亚型`,
    SUBMISSION_DATE: `提交日期`,
    SUBMIT: `提交`,
    SUBMIT_AUDIT: `提交审计`,
    SUBMIT_AUDIT_FOR: `提交 {dealer} 的审计`,
    SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `提交 {claimNumber} 的全部扣款`,
    SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `提交 {claimNumber} 的部分扣款`,
    SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `提交 {claimNumber} 的借方百分比索赔`,
    SUBMIT_REQUEST: `提交请求`,
    SUBMITTED: `已提交`,
    SUBMITTED_AVAILABLE_TO_EDIT: `已提交 (可编辑)`,
    SUCCESS: `成功`,
    SUCCESS_MESSAGE_TITLE: `一项操作成功：`,
    SUCCESS_MESSAGES_TITLE: `多项操作成功：`,
    SUPPLIER_WARRANTY: `供应商保修`,
    SURVEY_QUESTIONS: `调查问题`,
    SUSPENDED: `暂停`,
    SWEDISH: `瑞典语`,
    SYSTEM_SELECTED_CLAIMS: `系统选择的索赔`,
    SYSTEM_SELECTED_CLAIMS_WITH_COUNT: `系统选择的索赔 ({count})`,
    TABM: `TABM`,
    TAX: `税`,
    TCSM: `TCSM`,
    TCSM_COMMENTS: `TCSM注释`,
    TCSM_ID: `TCSM ID`,
    TECH_ID: `技术人员 ID`,
    TERMINATED: `已终止`,
    TERMINATES: `终止日期`,
    TERRITORY: `地区`,
    TEST: `测试`,
    TEST_RESULTS_CODE: `测试结果代码`,
    THEME: `主题`,
    TIME_LIMIT: `时间限制`,
    TIME_ZONE: `时区`,
    TITLE: `标题`,
    TITLE_IS_REQUIRED: `标题为必填项`,
    TO: `至`,
    TODAY: `当日`,
    TOO_MANY_RESULTS: `您的请求返回的结果太多。 请缩小搜索范围并重试。`,
    TOTAL: `总计`,
    TOTAL_AMOUNT: `总计`,
    TOTAL_AMOUNT_IN_LOCAL_CURRENCY: `总计（单位：兹罗提）`,
    TOTAL_APPROVED: `批复总计`,
    TOTAL_APPROVED_CLAIM_VALUE: `批准的索赔值总计`,
    TOTAL_APPROVED_INCLUDING_TAXES: `批准的含税总额`,
    TOTAL_APPROVED_WITHOUT_ADDITIVES: `批准的不含补贴总额`,
    TOTAL_CONTRIBUTION: `总分摊金额`,
    TOTAL_REIMBURSED: `总赔付`,
    TOTAL_REIMBURSED_WITH_CURRENCY: `总赔付 ({currency})`,
    TOTAL_REQUESTED: `申请总计`,
    TOTAL_REQUESTED_CLAIM_VALUE: `申请的索赔值总计`,
    TOTAL_UNPAID: `未赔付总计`,
    TRACKING_NUMBER: `跟踪编号`,
    TRANSFER: `移交`,
    TRANSFER_ALL: `全部转移`,
    TRANSFER_APPROVALS: `移交批准`,
    TRANSFER_APPROVALS_TAB: `移交批准 ({count})`,
    TRANSFER_CREATED: `已创建移交`,
    TRANSFER_DEALER_RECOMMENDATIONS: `转移经销商建议`,
    TRANSFER_REJECTED: `转移被拒绝`,
    TRANSFER_UPDATED_SUCCESSFULLY: `移交更新成功`,
    TRANSFERALL_DEALER_RECOMMENDATIONS: `转移所有经销商建议`,
    TRANSFERS: `移交`,
    TRAVEL: `差旅`,
    TURKISH: `土耳其语`,
    TWO_PERCENT_WITHHOLD_VALUE: `2％扣压值`,
    TYPE: `类型`,
    TYPES: `类型`,
    UNABLE_TO_CONTACT_THE_SERVER: `无法连接服务器`,
    UNABLE_TO_COPY_ATTACHMENTS: `我们无法复制原始索赔中的附件，请在提交新索赔之前进行审核。`,
    UNABLE_TO_LOAD_CUSTOMER_DETAILS: `无法加载客户详细信息`,
    UNDO: `撤消`,
    UNDO_REGISTRATION: `撤销注册`,
    UNDO_REGISTRATION_SUCCESSFULL: `撤销注册成功`,
    UNIT: `单位`,
    UNIT_1: `单位 1`,
    UNIT_2: `单位 2`,
    UNIT_3: `单位 3`,
    UNIT_OF_MEASURE: `计量单位`,
    UNPAID_LABOR: `未赔付工时`,
    UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: `未赔付的人工补贴 - 不包括 PIP`,
    UNPAID_LABOR_ADDITIVES_PIPS: `未赔付的人工补贴 - PIP`,
    UNPAID_OTHER_CREDITS: `未赔付的其他赔付项`,
    UNPAID_PARTS: `未赔付零件`,
    UNPAID_PARTS_ADDITIVE: `未赔付的零件补贴`,
    UNPAID_TRAVEL: `未赔付差旅`,
    UNRECONCIL: `取消对帐`,
    UNRECONCILE_CLAIM : `取消对帐索赔`,
    UNSUB: `编辑`,
    UNSUBMIT_CLAIM: `编辑索赔单`,
    UPDATE: `更新`,
    UPDATE_CUSTOMER_INFORMATION: `更新客户信息`,
    UPDATE_LABOR_RATES: `更新工时费率`,
    UPDATE_LAYOUT: `更新布局`,
    UPDATE_MACHINE_STATUS: `更新机器状态`,
    UPDATE_MACHINE_STATUS_HISTORY: `更新机器状态历史记录`,
    UPDATE_REGISTRATION: `更新注册`,
    UPDATE_SELECTED: `更新选定`,
    UPDATED: `更新日期`,
    UPDATED_BY: `更新者`,
    UPDATED_DATE_FROM: `更新日期从`,
    UPDATED_DATE_TO: `更新日期至`,
    UPLOAD_DOCUMENT: `上传文档`,
    UPTIME_ASSURANCE: `正常运行时间保证`,
    USEFUL_LINKS: `有用的链接`,
    USER: `用户`,
    USER_PREFERENCES_UPDATED: `用户偏好设置已更新`,
    USER_SELECTED: `用户选择`,
    USER_SELECTED_CLAIMS_WITH_COUNT: `用户选择的索赔 ({count})`,
    USERS_INFORMATION: `用户信息`,
    VALIDATE: `确认`,
    VALIDATE_CLAIM: `确认索赔`,
    VALUE: `值`,
    VALUE_OF_REPAIR: `修理值`,
    VIEW_CLAIM: `查看索赔`,
    VIEW_DETAILS: `查看详细信息`,
    VIEW_OPEN_PIPS: `查看未结 PIP`,
    VIEW_PIP: `查看 PIP`,
    VIEW_PRODUCTS: `查看产品`,
    VIEW_PRODUCTS_AND_UPDATE_INFO: `查看产品和更新信息`,
    VIEW_UPDATE: `查看/更新`,
    VSR_MESSAGES: `VSR 消息`,
    WAITING_FOR_DLR_INV: `等待经销商发票`,
    WAITING_FOR_INVOICE: `等待发票 ({count})`,
    WAITING_SINCE: `等待始于`,
    WARNING_MESSAGE_TITLE: `已发送一个警告：`,
    WARNING_MESSAGES: `警告信息`,
    WARNING_MESSAGES_TITLE: `已发送多个警告：`,
    WARRANTY: `保修`,
    WARRANTY_ADMIN: `保修管理`,
    WARRANTY_CLAIM_TYPE: `保修索赔类型`,
    WARRANTY_COVERAGE: `保修范围`,
    WARRANTY_EXPIRATION: `保修到期`,
    WARRANTY_TYPE: `保修类型`,
    WARRANTY_TYPES: `保修类型`,
    WEAR_PARTS: `磨损部件`,
    WEAR_PARTS_COVERAGE: `磨损部件覆盖`,
    WELCOME: `欢迎`,
    WINTERIZATION: `防冻`,
    WIP: `进行中的工作`,
    WITH_ADDITIVES: `含补贴`,
    WITNESS_FIRST_NAME: `见证人的名`,
    WITNESS_LAST_NAME: `见证人的姓`,
    WORK_ORDER: `工单`,
    WORK_ORDER_NUMBER: `工单号`,
    WORK_ORDER_ONE: `工单 1`,
    WORK_ORDER_ONE_IS_REQUIRED: `需要填写工单 1`,
    WORK_ORDER_THREE: `工单 3`,
    WORK_ORDER_THREE_IS_REQUIRED: `需要填写工单 3`,
    WORK_ORDER_TWO: `工单 2`,
    WORK_REPAIR_ORDER: `维修工单`,
    YES: `是`,
    YES_LOWERCASE: `是`
});



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-i18n/lib/zh.js